/**
 * Matsubishi Product Compare
 * 商品選択 → 比較表示
 */
(function () {
  'use strict';

  var MAX_ITEMS = 10;
  // v2: 価格を最小単位(円×100)へ正規化した際に旧形式(円のまま)の持ち越しを防ぐためキーを更新
  var STORAGE_KEY = 'matsubishi_compare_v2';
  var FAV_STORAGE_KEY = 'matsubishi_favorites';
  var FAV_PRODUCTS_KEY = 'matsubishi_favorites_products';

  // ---- Helpers ----

  function esc(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function formatPrice(price) {
    if (!price && price !== 0) return '-';
    var num = Math.round(parseFloat(price));
    if (isNaN(num)) return '-';
    // 価格は全データソースで最小単位(円×100)に正規化して保持する。
    // .js API / data-compare-price / favoritesキャッシュは元から最小単位、
    // products.json(円の文字列)は mapProducts 側で×100 している。
    num = Math.round(num / 100);
    return '\xA5' + num.toLocaleString('ja-JP');
  }

  // ---- Storage ----

  function getSelected() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function setSelected(items) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function isSelected(handle) {
    return getSelected().some(function (p) { return p.handle === handle; });
  }

  function addSelected(product) {
    var items = getSelected();
    if (items.length >= MAX_ITEMS) return false;
    if (items.some(function (p) { return p.handle === product.handle; })) return false;
    items.push(product);
    setSelected(items);
    return true;
  }

  function removeSelected(handle) {
    var items = getSelected().filter(function (p) { return p.handle !== handle; });
    setSelected(items);
  }

  function getFavHandles() {
    try { return JSON.parse(localStorage.getItem(FAV_STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function getFavCache() {
    try { return JSON.parse(localStorage.getItem(FAV_PRODUCTS_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  // ---- Fetch product data ----

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        return {
          handle: p.handle,
          title: p.title,
          image: p.featured_image || (p.images && p.images[0]) || '',
          price: p.price,
          url: '/products/' + p.handle,
          description: p.description ? p.description.replace(/<[^>]+>/g, '').substring(0, 200) : '',
          tags: p.tags || [],
          type: p.type || '',
          metafields: null // fetched separately if needed
        };
      })
      .catch(function () { return null; });
  }

  function fetchProductMetafields(handle) {
    return fetch('/products/' + handle + '?view=compare-meta')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return {};
        try {
          var match = html.match(/<!--COMPARE_META([\s\S]*?)COMPARE_META-->/);
          return match ? JSON.parse(match[1]) : {};
        } catch (e) { return {}; }
      })
      .catch(function () { return {}; });
  }

  function mapProducts(data) {
    return (data.products || []).map(function (p) {
      return {
        handle: p.handle,
        title: p.title,
        image: (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '',
        price: p.variants && p.variants[0] && p.variants[0].price ? Math.round(parseFloat(p.variants[0].price) * 100) : '',
        url: '/products/' + p.handle,
        type: p.product_type || '',
        tags: Array.isArray(p.tags) ? p.tags : (p.tags || '').split(', ')
      };
    });
  }

  function fetchAllProducts() {
    return fetch('/products.json?limit=250')
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .then(function (data) {
        return mapProducts(data);
      })
      .catch(function (e) { console.error('[compare] fetchAllProducts error:', e); return []; });
  }

  function fetchSameCollection(collectionHandle) {
    var handle = collectionHandle || 'all';
    var url = '/collections/' + handle + '/products.json?limit=50';
    return fetch(url)
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .then(function (data) {
        return mapProducts(data);
      })
      .catch(function (e) { console.error('[compare] fetchSameCollection error:', e); return []; });
  }

  // ---- Selection Page ----

  var allProducts = [];
  var allProductsLoaded = false;
  var allProductsLoading = false;
  var recommendedProducts = [];
  var currentTab = 'recommended';
  var searchQuery = '';
  var originProduct = null;

  function loadAllProductsIfNeeded(container) {
    if (allProductsLoaded || allProductsLoading) return;
    allProductsLoading = true;
    fetchAllProducts().then(function (products) {
      allProducts = products;
      allProductsLoaded = true;
      allProductsLoading = false;
      if (currentTab === 'all' && document.querySelector('.compare-select__list')) {
        renderProductList(container);
      }
    });
  }

  function initSelectionPage() {
    var container = document.getElementById('compare-selection');
    if (!container) return;

    var params = new URLSearchParams(window.location.search);
    var handle = params.get('handle');
    var showView = params.get('view');

    // view=compare パラメータがあり、2件以上選択済みなら直接比較表示
    if (showView === 'compare' && getSelected().length >= 2) {
      showComparisonView(container);
      return;
    }

    // Render initial UI immediately
    renderSelectionPage(container);

    if (handle) {
      fetchProduct(handle).then(function (product) {
        if (product) {
          originProduct = product;
          addSelected(product);
          renderBar();
          updateGoBtn();
        }

        // Fetch same collection products
        var collectionHandle = params.get('collection') || 'all';
        fetchSameCollection(collectionHandle)
          .then(function (products) {
            recommendedProducts = products.filter(function (p) { return p.handle !== handle; });
            renderProductList(container);
          });
      });
    }
  }

  function renderSelectionPage(container) {
    var selected = getSelected();

    container.innerHTML =
      '<div class="compare-select__sticky">' +
      '<div class="compare-select__search">' +
        '<div class="compare-select__search-wrap">' +
          '<svg class="compare-select__search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
          '<input class="compare-select__search-input" type="text" placeholder="キーワードで探す" value="' + esc(searchQuery) + '">' +
        '</div>' +
      '</div>' +
      '<div class="compare-select__tabs">' +
        '<button class="compare-select__tab' + (currentTab === 'recommended' ? ' compare-select__tab--active' : '') + '" data-tab="recommended">類似商品</button>' +
        '<button class="compare-select__tab' + (currentTab === 'favorites' ? ' compare-select__tab--active' : '') + '" data-tab="favorites">お気に入り</button>' +
        '<button class="compare-select__tab' + (currentTab === 'all' ? ' compare-select__tab--active' : '') + '" data-tab="all">すべて</button>' +
        '<button class="compare-select__tab' + (currentTab === 'selected' ? ' compare-select__tab--active' : '') + '" data-tab="selected">選択中</button>' +
      '</div>' +
      '</div>' +
      '<div class="compare-select__list" id="compare-product-list"></div>' +
      '<div class="compare-select__bar">' +
        '<div class="compare-select__bar-inner">' +
          '<div class="compare-select__bar-items" id="compare-bar-items"></div>' +
          '<button class="compare-select__bar-btn" id="compare-go-btn"' + (selected.length < 2 ? ' disabled' : '') + '>比較する（' + selected.length + '/' + MAX_ITEMS + '）</button>' +
        '</div>' +
      '</div>';

    // Events
    var searchInput = container.querySelector('.compare-select__search-input');
    searchInput.addEventListener('input', function () {
      searchQuery = this.value;
      renderProductList(container);
    });

    container.querySelectorAll('.compare-select__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        currentTab = this.dataset.tab;
        searchQuery = '';
        searchInput.value = '';
        container.querySelectorAll('.compare-select__tab').forEach(function (t) { t.classList.remove('compare-select__tab--active'); });
        this.classList.add('compare-select__tab--active');
        if (currentTab === 'all') {
          loadAllProductsIfNeeded(container);
        }
        renderProductList(container);
      });
    });

    var goBtn = document.getElementById('compare-go-btn');
    goBtn.addEventListener('click', function () {
      if (getSelected().length >= 2) {
        showComparisonView(container);
      }
    });

    renderProductList(container);
    renderBar();
  }

  function getFilteredProducts() {
    var products = [];
    var selectedHandles = getSelected().map(function (p) { return p.handle; });

    if (currentTab === 'recommended') {
      products = recommendedProducts;
    } else if (currentTab === 'favorites') {
      var favHandles = getFavHandles();
      var favCache = getFavCache();
      products = favHandles.map(function (handle) {
        var cached = favCache[handle];
        return cached ? {
          handle: handle,
          title: cached.title || handle,
          image: cached.image || '',
          price: cached.price || '',
          url: cached.url || '/products/' + handle,
          type: '',
          tags: []
        } : {
          handle: handle, title: handle, image: '', price: '', url: '/products/' + handle, type: '', tags: []
        };
      });
    } else if (currentTab === 'selected') {
      return getSelected();
    } else {
      products = allProducts;
    }

    // Filter out already selected
    products = products.filter(function (p) {
      return selectedHandles.indexOf(p.handle) === -1;
    });

    // Search filter
    if (searchQuery) {
      var q = searchQuery.toLowerCase();
      products = products.filter(function (p) {
        return (p.title && p.title.toLowerCase().indexOf(q) !== -1) ||
               (p.type && p.type.toLowerCase().indexOf(q) !== -1);
      });
    }

    return products;
  }

  function renderProductList(container) {
    var listEl = document.getElementById('compare-product-list');
    if (!listEl) return;

    var products = getFilteredProducts();
    var selected = getSelected();
    var atMax = selected.length >= MAX_ITEMS;

    if (currentTab === 'recommended' && products.length === 0 && !searchQuery) {
      listEl.innerHTML = '<p class="compare-select__empty">類似商品が見つかりませんでした</p>';
      return;
    }

    if (currentTab === 'favorites' && getFavHandles().length === 0) {
      listEl.innerHTML = '<p class="compare-select__empty">お気に入りに登録された商品がありません</p>';
      return;
    }

    if (currentTab === 'all' && !allProductsLoaded) {
      listEl.innerHTML = '<p class="compare-select__empty">商品を読み込み中...</p>';
      return;
    }

    if (products.length === 0) {
      listEl.innerHTML = '<p class="compare-select__empty">' + (searchQuery ? '「' + esc(searchQuery) + '」に一致する商品がありません' : '商品がありません') + '</p>';
      return;
    }

    listEl.innerHTML = '<p class="compare-select__count">' + products.length + '件</p>' +
      products.map(function (p) {
        var priceStr = p.price || p.price === 0 ? formatPrice(p.price) : '';
        return (
          '<div class="compare-select__card">' +
            '<div class="compare-select__card-image">' +
              (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="120" height="120">' : '') +
            '</div>' +
            '<div class="compare-select__card-info">' +
              '<p class="compare-select__card-title">' + esc(p.title) + '</p>' +
              (priceStr ? '<p class="compare-select__card-price">' + priceStr + '</p>' : '') +
            '</div>' +
            (currentTab === 'selected'
              ? '<button class="compare-select__card-btn compare-select__card-btn--remove" data-handle="' + esc(p.handle) + '">解除する</button>'
              : '<button class="compare-select__card-btn" data-handle="' + esc(p.handle) + '"' + (atMax ? ' disabled' : '') + '>選択する</button>') +
          '</div>'
        );
      }).join('');

    // Add click handlers
    listEl.querySelectorAll('.compare-select__card-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = this.dataset.handle;
        if (currentTab === 'selected') {
          removeSelected(handle);
          renderSelectionPage(container);
          return;
        }
        var product = products.find(function (p) { return p.handle === handle; });
        if (product) {
          addSelected(product);
          renderProductList(container);
          renderBar();
          updateGoBtn();
          // Update selected tab
          var selectedTab = container.querySelector('[data-tab="selected"]');
          if (selectedTab) selectedTab.textContent = '選択中';
        }
      });
    });
  }

  function renderBar() {
    var barItems = document.getElementById('compare-bar-items');
    if (!barItems) return;

    var selected = getSelected();
    var slots = [];

    for (var i = 0; i < MAX_ITEMS; i++) {
      if (selected[i]) {
        slots.push(
          '<div class="compare-select__bar-slot compare-select__bar-slot--filled">' +
            (selected[i].image ? '<img src="' + esc(selected[i].image) + '" alt="' + esc(selected[i].title) + '" width="48" height="48">' : '<span class="compare-select__bar-slot-empty"></span>') +
            '<button class="compare-select__bar-remove" data-handle="' + esc(selected[i].handle) + '" aria-label="削除">×</button>' +
          '</div>'
        );
      } else {
        slots.push('<div class="compare-select__bar-slot"><span class="compare-select__bar-slot-num">' + (i + 1) + '</span></div>');
      }
    }

    barItems.innerHTML = slots.join('');

    barItems.querySelectorAll('.compare-select__bar-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeSelected(this.dataset.handle);
        var container = document.getElementById('compare-selection');
        renderProductList(container);
        renderBar();
        updateGoBtn();
      });
    });
  }

  function updateGoBtn() {
    var btn = document.getElementById('compare-go-btn');
    if (!btn) return;
    var count = getSelected().length;
    btn.disabled = count < 2;
    btn.textContent = '比較する（' + count + '/' + MAX_ITEMS + '）';
  }

  // ---- Comparison View ----

  function showComparisonView(container) {
    var selected = getSelected();
    if (selected.length < 2) return;

    container.innerHTML =
      '<div class="compare-view__loading">比較データを読み込み中...</div>';

    // Fetch product data + metafields in parallel
    Promise.all(selected.map(function (p) {
      return Promise.all([
        fetch('/products/' + p.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }),
        fetchProductMetafields(p.handle)
      ]).then(function (results) {
        var product = results[0];
        var meta = results[1];
        if (product) product._meta = meta || {};
        return product;
      });
    })).then(function (products) {
      renderComparisonTable(container, products.filter(Boolean));
    });
  }

  function renderComparisonTable(container, products) {
    if (products.length === 0) {
      container.innerHTML = '<p class="compare-view__empty">商品データの取得に失敗しました</p>';
      return;
    }

    var headerCols = products.map(function (p) {
      var imgSrc = p.featured_image || (p.images && p.images[0]) || '';
      return '<th class="compare-view__col">' +
        '<button class="compare-view__remove" data-handle="' + esc(p.handle) + '" aria-label="削除">×</button>' +
        '<a href="/products/' + esc(p.handle) + '">' +
          (imgSrc ? '<img class="compare-view__img" src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '</a>' +
      '</th>';
    }).join('');

    var bodyRows = '';

    // Title
    bodyRows += '<tr><th class="compare-view__label">商品名</th>' +
      products.map(function (p) {
        return '<td class="compare-view__cell"><a href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a></td>';
      }).join('') + '</tr>';

    // Price
    bodyRows += '<tr><th class="compare-view__label">価格</th>' +
      products.map(function (p) {
        var price = p.variants && p.variants[0] ? p.variants[0].price : p.price;
        return '<td class="compare-view__cell compare-view__cell--price">' + formatPrice(price) + '</td>';
      }).join('') + '</tr>';

    // レビュー
    bodyRows += '<tr><th class="compare-view__label">レビュー</th>' +
      products.map(function (p) {
        var rating = p._meta && p._meta.review_rating ? parseFloat(p._meta.review_rating) : 0;
        var count = p._meta && p._meta.review_count ? parseInt(p._meta.review_count, 10) : 0;
        if (count === 0) return '<td class="compare-view__cell">-</td>';
        var stars = '';
        for (var i = 1; i <= 5; i++) {
          if (i <= Math.floor(rating)) stars += '\u2605';
          else if (i - 0.5 <= rating) stars += '\u2606';
          else stars += '\u2606';
        }
        return '<td class="compare-view__cell">' + stars + ' ' + rating.toFixed(1) + '（' + count + '件）</td>';
      }).join('') + '</tr>';

    // 商品概要 (custom._description)
    bodyRows += '<tr><th class="compare-view__label">商品概要</th>' +
      products.map(function (p) {
        var desc = (p._meta && p._meta.description) || '';
        if (!desc) {
          desc = (p.body_html || '').replace(/<[^>]+>/g, '').substring(0, 150);
          if (desc.length >= 150) desc += '...';
        }
        return '<td class="compare-view__cell compare-view__cell--desc">' + esc(desc) + '</td>';
      }).join('') + '</tr>';

    // おすすめ人数 (custom._serving)
    bodyRows += '<tr><th class="compare-view__label">おすすめ人数</th>' +
      products.map(function (p) {
        return '<td class="compare-view__cell">' + esc((p._meta && p._meta.serving) || '-') + '</td>';
      }).join('') + '</tr>';

    // サイズ・数量 (custom._size-quantity)
    bodyRows += '<tr><th class="compare-view__label">サイズ・数量</th>' +
      products.map(function (p) {
        return '<td class="compare-view__cell">' + esc((p._meta && p._meta.size_quantity) || '-') + '</td>';
      }).join('') + '</tr>';

    // Action row - 商品を見る + カートに追加
    bodyRows += '<tr><th class="compare-view__label"></th>' +
      products.map(function (p) {
        var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
        var available = p.variants && p.variants[0] ? p.variants[0].available : false;
        var soldOutLabel = '売り切れ';
        if (p._meta && p._meta.reservation_start_date) {
          var parts = p._meta.reservation_start_date.split('-');
          soldOutLabel = parts[0] + '年' + parseInt(parts[1], 10) + '月予約開始';
        }
        return '<td class="compare-view__cell compare-view__cell--actions">' +
          '<a href="/products/' + esc(p.handle) + '" class="compare-view__detail-btn">商品を見る</a>' +
          (available && variantId
            ? '<button class="compare-view__cart-btn" data-variant-id="' + variantId + '">カートに追加</button>'
            : '<button class="compare-view__cart-btn" disabled>' + esc(soldOutLabel) + '</button>') +
        '</td>';
      }).join('') + '</tr>';

    var addSlot = products.length < MAX_ITEMS
      ? '<th class="compare-view__col compare-view__col--add"><button class="compare-view__add-btn" id="compare-add-more">＋<br>商品を追加</button></th>'
      : '';

    container.innerHTML =
      '<div class="compare-view__actions">' +
        '<button class="compare-view__back" id="compare-back">← 商品選択に戻る</button>' +
      '</div>' +
      '<div class="compare-view__table-wrap">' +
        '<table class="compare-view__table">' +
          '<thead><tr><th class="compare-view__label-col"></th>' + headerCols + addSlot + '</tr></thead>' +
          '<tbody>' + bodyRows + '</tbody>' +
        '</table>' +
      '</div>';

    // Events
    document.getElementById('compare-back').addEventListener('click', function () {
      renderSelectionPage(container);
    });

    container.querySelectorAll('.compare-view__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeSelected(this.dataset.handle);
        var remaining = getSelected();
        if (remaining.length < 2) {
          renderSelectionPage(container);
        } else {
          showComparisonView(container);
        }
      });
    });

    var addMoreBtn = document.getElementById('compare-add-more');
    if (addMoreBtn) {
      addMoreBtn.addEventListener('click', function () {
        renderSelectionPage(container);
      });
    }

    // カートに追加ボタン
    container.querySelectorAll('.compare-view__cart-btn[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = this.dataset.variantId;
        var button = this;
        button.disabled = true;
        button.textContent = '追加中...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
        .then(function (r) {
          if (!r.ok) { throw new Error('cart add failed: ' + r.status); }
          return r.json();
        })
        .then(function () {
          button.textContent = '追加しました';
          button.classList.add('is-added');
          // カートカウントを更新
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var countEls = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
            countEls.forEach(function (el) { el.textContent = cart.item_count; });
          });
          setTimeout(function () {
            button.disabled = false;
            button.textContent = 'カートに追加';
            button.classList.remove('is-added');
          }, 2000);
        })
        .catch(function () {
          button.textContent = '追加できませんでした';
          setTimeout(function () {
            button.disabled = false;
            button.textContent = 'カートに追加';
          }, 2000);
        });
      });
    });
  }

  // ---- Compare Mode (collection page checkboxes) ----

  var compareMode = false;

  function applyCompareModeVisuals() {
    var toggle = document.getElementById('compare-mode-toggle');
    if (toggle) {
      toggle.classList.toggle('is-active', compareMode);
      var toggleLabel = compareMode ? '比較モードを終了' : '商品を比較する';
      // textContentは同値でもchildList変異を発生させ、observerと無限ループになるため差分時のみ書く
      if (toggle.textContent !== toggleLabel) toggle.textContent = toggleLabel;
    }

    // チェックボックスの表示/非表示
    document.querySelectorAll('.compare-checkbox').forEach(function (label) {
      label.style.display = compareMode ? '' : 'none';
    });

    // 比較モード中はカードリンクのオーバーレイを無効化
    var grid = document.getElementById('product-grid');
    if (grid) {
      grid.classList.toggle('compare-mode-active', compareMode);
    }
  }

  function toggleCompareMode() {
    compareMode = !compareMode;
    applyCompareModeVisuals();

    // フローティングバー
    if (compareMode) {
      syncCheckboxes();
      updateCompareFloatingBar();
    } else {
      var bar = document.getElementById('compare-floating-bar');
      if (bar) bar.remove();
    }
  }

  function syncCheckboxes() {
    var selected = getSelected();
    document.querySelectorAll('.compare-checkbox').forEach(function (el) {
      var handle = el.getAttribute('data-compare-handle');
      var checked = selected.some(function (p) { return p.handle === handle; });
      el.classList.toggle('is-checked', checked);
    });
  }

  function handleCompareCheckboxClick(el) {
    var handle = el.getAttribute('data-compare-handle');
    var isChecked = el.classList.contains('is-checked');

    if (isChecked) {
      removeSelected(handle);
      el.classList.remove('is-checked');
    } else {
      var product = {
        handle: handle,
        title: el.getAttribute('data-compare-title') || '',
        image: el.getAttribute('data-compare-image') || '',
        price: el.getAttribute('data-compare-price') || '',
        url: el.getAttribute('data-compare-url') || '/products/' + handle,
        type: '',
        tags: []
      };
      var added = addSelected(product);
      if (added) {
        el.classList.add('is-checked');
      }
    }

    updateCompareFloatingBar();
  }

  function updateCompareFloatingBar() {
    var count = getSelected().length;
    var bar = document.getElementById('compare-floating-bar');

    if (count === 0 || !compareMode) {
      if (bar) bar.remove();
      return;
    }

    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'compare-floating-bar';
      bar.className = 'compare-floating-bar';
      document.body.appendChild(bar);
    }

    bar.innerHTML =
      '<a href="/pages/compare?view=compare" class="compare-floating-bar__btn">' +
        '比較する（' + count + '件）' +
      '</a>' +
      '<button type="button" class="compare-floating-bar__clear" id="compare-clear-btn">クリア</button>';

    document.getElementById('compare-clear-btn').addEventListener('click', function () {
      setSelected([]);
      syncCheckboxes();
      updateCompareFloatingBar();
    });
  }

  function setupCompareMode() {
    if (!document.getElementById('compare-mode-toggle')) return;
    if (!document.getElementById('product-grid')) return;

    // facets.js が #ProductGridContainer.innerHTML を丸ごと置換するため、
    // 要素直付けではなく document へ委譲する(キャプチャフェーズ)
    document.addEventListener('click', function (e) {
      if (e.target.closest('#compare-mode-toggle')) {
        e.preventDefault();
        toggleCompareMode();
        return;
      }

      if (!compareMode) return;
      if (!e.target.closest('#product-grid')) return;

      // チェックボックスのクリック
      var el = e.target.closest('.compare-checkbox');
      if (el) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleCompareCheckboxClick(el);
        return;
      }

      // 比較モード中はカード内のリンク遷移だけ無効化する
      // (カード外 = 0件表示の「すべて削除する」等の復帰リンクは素通しさせる)
      var card = e.target.closest('.card-wrapper');
      if (!card) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      // カード画像クリックでもチェックボックスを操作
      var checkbox = card.querySelector('.compare-checkbox');
      if (checkbox) {
        handleCompareCheckboxClick(checkbox);
      }
    }, true);

    // 絞り込み/並び替えでグリッドが再描画されたら視覚状態を復元する
    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (!compareMode) return;
        applyCompareModeVisuals();
        syncCheckboxes();
        // childListのみ監視(facets.jsはコンテナ直下を丸ごと差し替える)。
        // subtree監視だとトグル文言のtextContent書き込み自体が変異として拾われループする
      }).observe(gridContainer, { childList: true });
    }
  }

  // ---- Init ----

  document.addEventListener('DOMContentLoaded', function () {
    try { initSelectionPage(); } catch (e) { console.error('[compare] init error:', e); }
    setupCompareMode();
  });
})();
